/**
 * Axios 401 → re-probe BFF session. No legacy /v2/auth refresh tokens.
 */
import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import { axiosInstance } from "./axios";
import { validateSession, startBffLogin } from "./auth";

let installed = false;

export function setupAxiosSessionRefresh(): () => void {
  if (installed) return () => undefined;
  installed = true;

  const id = axiosInstance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const status = error.response?.status;
      const config = error.config as InternalAxiosRequestConfig | undefined;
      const url = config?.url || "";
      if (status !== 401) throw error;
      if (url.includes("/api/auth/")) throw error;

      const session = await validateSession();
      if (!session) {
        startBffLogin(
          typeof window !== "undefined" ? window.location.pathname : "/overview",
        );
      }
      throw error;
    },
  );

  return () => {
    axiosInstance.interceptors.response.eject(id);
    installed = false;
  };
}
